import { useEffect, useState } from 'react';
import { ArrowUp, Phone } from 'lucide-react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    // Show button when page is scrolled down
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="fixed bottom-4 right-4 z-50 space-y-4">
      {/* Phone Call Button */}
      <a
        href="tel:+38627525020"
        className="flex items-center justify-center p-3 rounded-full bg-primary shadow-md hover:bg-primary-700 transition-all duration-300"
        aria-label="Call us"
      >
        <Phone className="h-5 w-5 text-white" />
      </a>
      
      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className={`flex items-center justify-center p-3 rounded-full bg-primary shadow-md hover:bg-primary-700 
        transition-all duration-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}`}
        aria-label="Scroll to top"
      >
        <ArrowUp className="h-5 w-5 text-white" />
      </button>
    </div>
  );
};

export default ScrollToTop;